/*
 * @author BSG <dev@bsgroup.eu>
 * @copyright Better Software Group S.A.
 * @version: 1.0
 */
import { createContext } from "react";

const defaultValue = {
  query: undefined,
  categories: undefined,
};

export interface ISearchContext {
  query?: string;

  categories?: number[];
}

export const SearchContext = createContext<ISearchContext>(defaultValue);
